<script>
  import {push} from 'svelte-spa-router';
  import { DateInput } from 'date-picker-svelte'
  import Menu from './Menu.svelte';

  const urlgue = `/ianua/bin/gue`;
  const urlpag = `/ianua/bin/zpag`;

  let _res = undefined;
  let _err = '';
  let gue = {
    name: "",
    mail: "",
    note: "",
  };
  let pag = {
    gue: '',
    f: new Date(),
    t: new Date(),
  }
  let zurl;
  
  // DatePicker locale
  let dploc = {
    weekdays: [
      'Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'sab'
    ],
    months: [
      'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
    ],
    weekStartsOn: 1
  };

  //DatePicker min e max
  let dMin = new Date("2024-01-01 00:00");
  let dMax = new Date("2099-12-31 23:59");
  
  function reset() {
    _err = '';
    gue.name = '';
    gue.mail = '';
    gue.note = '';
    return;
  };

  async function addGue(){
    // https://web.dev/articles/fetch-api-error-handling
    // https://dev.to/dionarodrigues/fetch-api-do-you-really-know-how-to-handle-errors-2gj0
    if (gue.name === "") {
      _err = 'Il campo nome è necessario sia valorizzato';
      return;
    }

    try {
      const res = await fetch(urlgue, {
	method: 'PUT',
	headers: {
	  'Accept': 'application/json',
	  'Content-Type': 'application/json'
	},
	body: JSON.stringify(gue),
      });
      if (res.ok) {
	_res = await res.json();
	// console.log(_res);
      } else {
	if (res.status === 401) push('/login');
	if (res.status === 404) throw new Error('Not found');
	throw new Error(res.status);
      }
    } catch(err) {
      _err = err;
    };

    if (_res) {
      pag.gue = _res.id;
    }
  };

  async function addPag(){
    if (pag.f > pag.t) {
      _err = 'La data di inizio non può essere successiva alla data di fine';
      return;
    }

    try {
      const res = await fetch(urlpag, {
	method: 'PUT',
	headers: {
	  'Accept': 'application/json',
	  'Content-Type': 'application/json'
	},
	body: JSON.stringify(pag),
      });
      if (res.ok) {
	_res = await res.json();
      } else {
	if (res.status === 401) push('/login');
	if (res.status === 404) throw new Error('Not found');
	throw new Error(res.status);
      }
    } catch(err) {
      _err = err;
    };
  };

  // https://svelte.dev/repl/3194502389af4e22991f8bb0c61d65cf?version=4.2.18
  function copyclip() {
    zurl.select();
    document.execCommand('copy');
    return;
  };
  
</script>

<Menu />

<div id="main" class="wrapper style1">
  <div class="container">
    <section id="content">
      
      {#if !_res}
	<h3>Inserisci nuovo ospite</h3>
	<form method="post">
	  <div class="row gtr-uniform gtr-50">
	    <div class="col-6 col-12-xsmall">
	      <input bind:value="{gue.name}" type="text" name="name" id="name" placeholder="Nome" />
	    </div>
	    <div class="col-6 col-12-xsmall">
	      <input bind:value="{gue.mail}" type="email" name="mail" id="mail" placeholder="Email" />
	    </div>
	    <div class="col-12">
	      <textarea bind:value="{gue.note}" name="note" id="note" placeholder="Note..." rows="6"></textarea>
	    </div>
	    <div class="col-12">
	      <ul class="actions">
		<li><input on:click|preventDefault="{addGue}" type="submit" value="Invia" class="primary" /></li>
		<li><input on:click|preventDefault="{reset}" type="reset" value="Reset" /></li>
	      </ul>
	    </div>
	  </div>
	</form>
	{#if _err}
	  <div class="row gtr-uniform gtr-50">
	    <div class="col-12 col-12-xsmall">
	      <strong class="warning">{_err}</strong>
	    </div>
	  </div>
	{/if}
      {:else if _res.url === undefined}
	<h3>Seleziona le date di inizio e fine soggiorno per {_res.name}</h3>
	<!-- fare in modo si possa scegliere quali act può attivare il gue, -->
	<!-- intanto li prende tutti e tanti saluti                         -->

	<br />
	<form>
	  <div class="row gtr-uniform gtr-50">
	    <div class="col-3 col-12-xsmall">
	      Data inizio: <DateInput bind:value="{pag.f}" locale="{dploc}" timePrecision="minute" format="yyyy-MM-dd HH:mm" min="{dMin}" max="{dMax}" id="pag.f" />
	    </div>
	    <div class="col-3 col-12-xsmall">
	      Data fine: <DateInput bind:value="{pag.t}" locale="{dploc}" timePrecision="minute" format="yyyy-MM-dd HH:mm" min="{dMin}" max="{dMax}" id="pag.t" />
	    </div>
	  </div>
	  <br />
	  <div class="col-6 col-12-xsmall">
	    <ul class="actions">
	      <li><input on:click|preventDefault="{addPag}" type="submit" value="Invia" class="primary" /></li>
	      <li><input on:click|preventDefault="{reset}" type="reset" value="Reset" /></li>
	    </ul>
	  </div>
	</form>
	{#if _err}
	  <div class="row gtr-uniform gtr-50">
	    <div class="col-12 col-12-xsmall">
	      <strong class="warning">{_err}</strong>
	    </div>
	  </div>
	{/if}
      {:else}
	<div class="row gtr-uniform gtr-50">
	  <div class="col-12">
	    <input bind:this="{zurl}" type="text" value="{_res.url}" class="zurl" />
	  </div>
	  <div class="col-6 col-12-xsmall">
	    <ul class="actions">
	      <li><input on:click|preventDefault="{copyclip}" type="submit" value="Copia" class="primary" /></li>
	    </ul>
	  </div>
	</div>
      {/if}

    </section>
  </div>
</div>

<style>
  :global(body) {
    --date-picker-foreground: #ffffff;
    --date-picker-background: #1c1d26;
    --date-picker-highlight-border: hsl(var(--deg), 98%, 49%);
    --date-picker-highlight-shadow: hsla(var(--deg), 98%, 49%, 50%);
    --date-picker-selected-color: hsl(var(--deg), 100%, 85%);
    --date-picker-selected-background: hsla(var(--deg), 98%, 49%, 20%);
  }
</style>
